import React, {useEffect, useState, useContext} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Form, Formik} from 'formik';
import {Button, Grid, TextField} from '@material-ui/core';
import ErrorBoundaryForComponents from '../../../../util/ErrorBoundaryForComponents';
import PageLoader from '../../../../components/PageLoader';
import {SuccessSnackbar, ErrorSnackbar} from '../../../../components/CustomSnackBar';
import EventTacticSearchTable from './EventTacticSearchTable';
import {ThemeContext} from '../../../../themes/ThemeProvider';
import {ResetMessage as resetMessage, ResetStatus as resetStatus} from '../../../../redux/reducers/EventTactics/EventTactics';

const SearchEventContainer = ({
  setValue,
  setEventTacticCode,
  setEventClientData,
  eventClientData,
}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const [searchData, setSearchData] = useState({});
  const dispatch = useDispatch();
  const handleSubmit = (data) => {
    setSearchData(data);
  };
  const {isLoading, successMsg, errorMsg, addEventTacticStatus} = useSelector(
    ({addEventTactic}) => addEventTactic,
  );
  const initialValues = {
    code: '',
    description: '',
  };

  useEffect(() => {
    if (addEventTacticStatus === 200 || addEventTacticStatus === 500) {
      setTimeout(() => {
        dispatch(resetMessage());
        dispatch(resetStatus());
      }, 3000);
    }
  }, [addEventTacticStatus]);

  return (
    <>
      <div>
        <Formik
          onSubmit={(values) => handleSubmit(values)}
          initialValues={initialValues}
          enableReinitialize
        >
          {(props) => {
            const {values, handleChange, resetForm, handleBlur} = props;
            return (
              <div className={classes.ruleGroupCard}>
                <Form autoComplete="off" noValidate>
                  <div>
                    <ErrorBoundaryForComponents>
                      <Grid spacing={2} container>
                        <Grid item xs={6} md={4} className="form-group">
                          <TextField
                            margin="dense"
                            variant="outlined"
                            className={` ${classes.labelName} ${classes.inputLabel}`}
                            placeholder={`Enter Code`}
                            label="Code"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            name="code"
                            value={values.code}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            fullWidth
                          />
                        </Grid>
                        <Grid item xs={6} md={4} className="form-group">
                          <TextField
                            className={` ${classes.labelName} ${classes.inputLabel}`}
                            margin="dense"
                            variant="outlined"
                            name="description"
                            placeholder={`Enter Description`}
                            label="Description"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            value={values.description}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            fullWidth
                          />
                        </Grid>
                      </Grid>
                      <div className="button-table-spacing-mb">
                        <Button
                          variant="contained"
                          className={`mx-1 ${classes.buttonRoot}`}
                          onClick={() => {
                            resetForm();
                          }}
                        >
                          Clear
                        </Button>
                        <Button
                          variant="contained"
                          type="submit"
                          className={`themeing-buttons mx-1 ${classes.buttonRoot}`}
                        >
                          Search
                        </Button>
                      </div>
                    </ErrorBoundaryForComponents>
                  </div>
                </Form>
                {isLoading && <PageLoader />}
                {errorMsg && <ErrorSnackbar errorMsg={errorMsg} />}
                {successMsg && <SuccessSnackbar successMsg={successMsg} />}
              </div>
            );
          }}
        </Formik>
        <EventTacticSearchTable
          setEventTacticCode={setEventTacticCode}
          setValue={setValue}
          searchData={searchData}
          setEventClientData={setEventClientData}
          eventClientData={eventClientData}
        />
      </div>
    </>
  );
};
export default SearchEventContainer;
